module.exports = __webpack_public_path__ + "img/emag.0268229f.png";